(function () {
  /**
   * DUBRii Anchor Scroll Fix
   * - Hash（#first-drop 等）が付いたら必ずスクロールする
   * - Drawerが開いていたら閉じてからスクロールする
   * - レイアウト確定待ち＆リトライで「閉じるけど動かない」を潰す
   */

  function closeHeaderDrawerIfOpen() {
    const headerDrawer = document.querySelector("header-drawer");
    if (!headerDrawer) return;

    const details = headerDrawer.querySelector("details");
    const summary = headerDrawer.querySelector("summary");

    if (details && details.hasAttribute("open") && summary) {
      summary.click();
    }
  }

  function getHeaderOffset() {
    const header = document.querySelector(".section-header");
    if (!header) return 0;
    const h = Math.round(header.getBoundingClientRect().height);
    return isNaN(h) ? 0 : h;
  }

  function scrollToElement(el, behavior) {
    const headerH = getHeaderOffset();
    const y = el.getBoundingClientRect().top + window.pageYOffset - headerH - 8;
    window.scrollTo({ top: y, behavior });
  }

  /**
   * hash の id にスクロール（複数回リトライ）
   */
  function forceScrollToHash(hash, behavior, attempt) {
    const id = (hash || "").replace("#", "").trim();
    if (!id) return;

    const el = document.getElementById(id);
    if (!el) return;

    // まずドロワー閉じ
    closeHeaderDrawerIfOpen();

    // 閉じのアニメ・レイアウト確定を待ってからスクロール
    const delay = attempt === 0 ? 80 : 120;
    window.setTimeout(() => {
      const before = window.pageYOffset || document.documentElement.scrollTop || 0;

      scrollToElement(el, behavior);

      // スクロールが打ち消されるケース対策でリトライ
      const after = window.pageYOffset || document.documentElement.scrollTop || 0;
      const moved = Math.abs(after - before) > 2;

      if (!moved && attempt < 10) {
        forceScrollToHash(hash, behavior, attempt + 1);
      }
    }, delay);
  }

  function handleHash(behavior) {
    if (!location.hash) return;
    forceScrollToHash(location.hash, behavior, 0);
  }

  // 1) ページ読み込み時（/pages/dubrii#first-drop の直リンク）
  window.addEventListener("load", () => {
    handleHash("auto");
  });

  // 2) hash が変わったら必ずスクロール（あなたの状況に最適）
  window.addEventListener("hashchange", () => {
    handleHash("smooth");
  });

  // 3) ドロワー内リンクを押したとき、閉じ→hashchangeでスクロールに乗せる
  //    （クリックが吸われても hashchange が起きればスクロールできる）
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;

      const href = a.getAttribute("href") || "";
      const id = href.replace("#", "").trim();
      if (!id) return;
      if (!document.getElementById(id)) return;

      // ここではスクロールしない。hash を確実に更新して hashchange に委譲する
      // ※同じhash連打でも動くよう、一旦空にしてから戻す
      e.preventDefault();
      closeHeaderDrawerIfOpen();

      const nextHash = `#${id}`;
      if (location.hash === nextHash) {
        history.replaceState(null, "", " ");
      }
      window.setTimeout(() => {
        location.hash = nextHash;
      }, 0);
    },
    true
  );
})();